__turbopack_context__.v({
  "skeleton": "RightSection-module__3EDrUq__skeleton",
});
